import React from "react";
import "./Fee.css";

function Fee() {
  return (
    <div className="Fee">
      <body className="Fee-body">
        <h1>LIFE MISSION の料金について</h1>
        <p>完全無料</p>

        <h4>ユーザーの皆様へ</h4>
        <p>
          このアプリを完全無料にする理由は
          <br />
          少しでも負担なくあなたに使ってほしいからです
          <br />
          <br />
          ぜひ、この「MISSION」という人生ゲームを楽しんでください
        </p>
      </body>
    </div>
  );
}

export default Fee;
